export default {
  header: 'components.views.generate-diecut-view.header'
}
